
import { Component, Vue } from 'vue-property-decorator'
import { NavBar, VideoCard, CreateVideoModal } from '@/components'
import FetchWrapper from '@/classes/fetchWrapper'
import store from '../store'

@Component({
  components: {
    NavBar,
    VideoCard,
    CreateVideoModal
  }
})
export default class VideosView extends Vue {
  data () {
    return {
      activeTab: 0,
      isLoading: false,
      myVideos: [],
      mySearchTerms: '',
      popularVideos: [],
      popularSearch: '',
      createVideoModalDisplay: false,
      unprocessedVideos: [],
      roles: [],
      isAdmin: false
    }
  }

  mounted () {
    this.roles = store.getters.getUserRoles
    this.isAdmin = this.roles ? this.roles.includes('ADMIN') : false
    if (!this.isAdmin) {
      this.getMyVideos()
      this.getPopularVideos()
    }
  }

  get isLoggedIn () {
    return this.$store.state.loggedIn
  }

  async searchMyVideos () {
    await this.getMyVideos()
  }

  clearSearchMyVideos () {
    this.mySearchTerms = ''
  }

  async getMyVideos () {
    this.isLoading = true
    try {
      var urlEnd = this.mySearchTerms !== '' ? `/${this.mySearchTerms}` : ''
      var url = encodeURI(`${process.env.VUE_APP_SERVERURL}/getMyVideos` + urlEnd)
      this.myVideos = await FetchWrapper.get(url)
      this.isLoading = false
    } catch (e) {
      this.myVideos = []
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get my videos.',
        canCancel: false
      })
    }
  }

  async searchPopularVideos () {
    await this.getPopularVideos()
  }

  clearSearchPopularVideos () {
    this.popularSearch = ''
  }

  async getPopularVideos () {
    this.isLoading = true
    try {
      var urlEnd = this.popularSearch !== '' ? `/${this.popularSearch}` : ''
      var url = encodeURI(`${process.env.VUE_APP_SERVERURL}/getPopularVideos` + urlEnd)
      this.popularVideos = await FetchWrapper.get(url)
      this.isLoading = false
    } catch (e) {
      this.popularVideos = []
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get popular videos.',
        canCancel: false
      })
    }
  }

  async getUnprocessedVideos () {
    this.isLoading = true
    try {
      this.unprocessedVideos = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getUnprocessedVideos`))
      this.unprocessedVideos.map(e => { e.captionsUrl = ''; return 0 })
      this.isLoading = false
    } catch (e) {
      this.unprocessedVideos = []
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get unprocessed videos.',
        canCancel: false
      })
    }
  }

  async processVideo (ytbId, captionsUrl) {
    try {
      this.isLoading = true

      var data = {
        ytbId,
        captionsUrl
      }

      const resp = await FetchWrapper.post(`${process.env.VUE_APP_SERVERURL}/processVideo`, data)
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Success',
        message: 'Video processed successfully',
        canCancel: false
      })
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not process video. Reason: ${e}`,
        canCancel: false
      })
    }
  }

  async processVideoLogs (videoId) {
    this.isLoading = true
    try {
      await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/processVideoLogs/${videoId}`))
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Success',
        message: 'Video Logs processed successfully',
        canCancel: false
      })
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not process Video Logs. Reason: ${e}`,
        canCancel: false
      })
    }
  }

  openNewVideoModal () {
    this.createVideoModalDisplay = true
  }

  async newVideoCreated () {
    await this.getMyVideos()
    this.createVideoModalDisplay = false
  }
}
